import {ServiceOptions} from 'types/commons'
import {SERVICE_MAP_AUTH} from './auth'
import {ServiceParam} from './ServiceParam'
import {SERVICE_MAP_GIFTSHOP} from './giftshop'

export const SERVICE_MAP: Record<keyof ServiceParam, ServiceOptions> = {
  ...SERVICE_MAP_AUTH,
  ...SERVICE_MAP_GIFTSHOP,
}
